<template>
    <div class="main-content">
        <the-header :title="t('Notifications')" :buttons="headerButtons"/>
        <nav-body :links="nav">
            <template-list
                    v-if="loading === false"
                    :type="$route.params.type"
                    :page="currentPage"
                    :visible-identifier="showIdentifier"
                    @openItem="openItem($event)"
                    @changePage="$router.push({name: $route.name, params: {type: $route.params.type, page: $event}})"
            />
        </nav-body>
    </div>
</template>
<script>
    import TemplateList from '../../../../admin/Pages/Templates/List';
    import TheHeader from '../../../../admin/Layout/TheHeader'
    import NavBody from '../../../../admin/Layout/NavBody'
    import {admin} from '../Admin'

    export default {
        mixins: [admin],
        components: {
            TheHeader,
            NavBody,
            TemplateList
        },
        watch: {
            '$route.params'(newValue, oldValue) {
                if (newValue.type !== oldValue.type) {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                    }, 50);
                }
            }
        },
        computed: {
            currentPage() {
                return parseInt(this.$route.params.page);
            },
            showIdentifier() {
                return !['patientTextMessages', 'patientMail'].includes(this.$route.params.type);
            }
        },
        methods: {
            openItem(event) {
                this.$router.push(
                    {
                        name: 'adminEditTemplateList',
                        params: {
                            type: this.$route.params.type,
                            id: event.id
                        }
                    }
                );
            }
        },
        data() {
            return {
                loading: false,
                headerButtons: [
                    {
                        type: 'link',
                        to: () => {
                            return {name: 'adminCreateTemplateList', params: {type: this.$route.params.type}};
                        },
                        name: this.t('Create'),
                        icon: 'plus',
                        styleClass: 'btn-success',
                    }
                ]
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/admin/template/List.vue